<template>
  <div class="w-100" style="min-height:38px;text-align:left;">
    <b-form>
      <b-form-group
        label="¿Hace usted ejercicio regularmente? Si dejó de ejercitarse hace más de 6 semanas responder que no. Si dejó de ejercitarse hace menos de 6 semanas considerar como si aún estuviera entrenando"
        label-for="input-1"
      >
        <b-form-select
          v-model="formData.exercise_time"
          :options="options.optionsExerciseTime"
          id="input-1"
          :disabled="disabled"
        />
      </b-form-group>
      <b-form-group
        label="¿El ejercicio es de sobrecarga o de otra actividad?"
        label-for="input-2"
        v-if="formData.exercise_time=='1' || formData.exercise_time=='2' || formData.exercise_time=='3'"
      >
        <b-form-select
          v-model="formData.exercise_type"
          :options="options.optionsExerciseType"
          id="input-2"
          :disabled="disabled"
        />
      </b-form-group>
      <b-form-group
        label="¿Cuántas veces por semana lleva a cabo entrenamiento de sobrecarga?"
        label-for="input-times-week"
        v-if="(formData.exercise_time=='1' || formData.exercise_time=='2' || formData.exercise_time=='3') && (formData.exercise_type=='1' || formData.exercise_type=='3')"
      >
        <b-form-select
          v-model="formData.times_week"
          :options="options.optionsTimesWeek"
          id="input-times-week"
          :disabled="disabled"
        />
      </b-form-group>
      <b-form-group
        label="¿Qué grado de intensidad (o dificultad) tienen sus sesiones de entrenamiento de fuerza?"
        label-for="input-3"
        v-if="formData.exercise_time=='1' || formData.exercise_time=='2' || formData.exercise_time=='3'"
      >
        <b-form-select 
          v-model="formData.intensity" 
          :options="options.optionsIntensity" 
          id="input-3" 
          :disabled="disabled"
        />
      </b-form-group>
      <b-form-group
        label="Seleccione el(los) grupo(s) de ejercicios más similar(es) a su rutina habitual de entrenamiento"
        label-for="input-exercise-amount"
        v-if="(formData.exercise_time=='1' || formData.exercise_time=='2' || formData.exercise_time=='3') && (formData.exercise_type=='1' || formData.exercise_type=='3')"
      >
        <b-form-checkbox-group 
          id="input-exercise-amount" 
          v-model="formData.exercise_level"
          :disabled="disabled"
        >
          <b-form-checkbox value="1" class="option-exercise-amount">
            <img src="../../assets/img/basico.jpg" alt="basico" />
          </b-form-checkbox>
          <b-form-checkbox value="2" class="option-exercise-amount">
            <img src="../../assets/img/intermedio1.jpg" alt="intermedio1" />
          </b-form-checkbox>
          <b-form-checkbox value="3" class="option-exercise-amount">
            <img src="../../assets/img/intermedio2.jpg" alt="intermedio2" />
          </b-form-checkbox>
          <b-form-checkbox value="4" class="option-exercise-amount">
            <img src="../../assets/img/avanzado.jpg" alt="avanzado" />
          </b-form-checkbox>
        </b-form-checkbox-group>
      </b-form-group>
      <b-form-group
        label="¿Dónde pretende entrenar? Seleccionar la opción más cercana en el caso de no calzar exactamente"
        label-for="input-4"
      >
        <b-form-select 
          v-model="formData.place" 
          :options="options.optionsPlace" 
          id="input-4" 
          :disabled="disabled"
        />
      </b-form-group>
      <b-form-group
        label="Si entrenará en casa y tiene implementos ¿Con qué implementos cuenta?"
        label-for="input-5"
        v-if="formData.place=='1'"
      >
        <b-form-checkbox-group 
          id="input-5" 
          v-model="formData.tools" 
          :options="options.optionsTools" 
          :disabled="disabled"
        />
      </b-form-group>
      <b-form-group
        label="Si entrenará en casa y no tiene implementos ¿Estás dispuesto a comprar bandas elásticas y/o TRX?"
        label-for="input-6"
        v-if="formData.place=='2'"
      >
        <b-form-select 
          v-model="formData.buy_tools" 
          :options="options.optionsBuyTools" 
          id="input-6" 
          :disabled="disabled"
        />
      </b-form-group>
      <b-form-group label="Marque los días en los que puede entrenar" label-for="input-7">
        <b-form-checkbox-group 
          id="input-7" 
          v-model="formData.days" 
          :options="options.optionsDays" 
          :disabled="disabled"
        />
      </b-form-group>
      <b-form-group
        label="¿Cuánto tiempo tiene para entrenar aproximadamente cada día? (indique horarios y no considere el tiempo que toma cambiarse ropa, ducharse, etc)"
        label-for="input-8"
      >
        <b-form-select 
          v-model="formData.time_per_day" 
          :options="options.optionsTimePerDay" 
          id="input-8" 
          :disabled="disabled"
        />
      </b-form-group>
      <b-form-group
        label="Ingresa información importante sobre ti, por ejemplo alguna lesión o enfermedad que afecte tu entrenamiento"
        label-for="input-9"
      >
        <b-form-textarea 
          id="input-9" 
          v-model="formData.observation" 
          rows="3" 
          max-rows="6" 
          aria-describedby="input-observation-feedback"
          :state="$v.formData.observation.$invalid ? false : null "
          :disabled="disabled"
        />
        <b-form-invalid-feedback id="input-observation-feedback">
          El texto es demasiado largo
        </b-form-invalid-feedback>
      </b-form-group>
    </b-form>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { maxLength } from 'vuelidate/lib/validators'

export default {
  computed: mapState(["login"]),
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function() {
    return {
      formData: {
        observation: "",
        exercise_time: null,
        exercise_type: null,
        times_week: null,
        intensity: null,
        place: null,
        tools: null,
        buy_tools: null,
        days: [],
        time_per_day: null,
        exercise_level: []
      },
      options: {
        optionsExerciseTime: [
          { value: 1, text: "Sí, he estado haciéndolo por MÁS de 12 meses" },
          { value: 2, text: "Sí, he estado haciéndolo por MÁS de 6 meses" },
          { value: 3, text: "Sí, he estado haciéndolo por MENOS de 6 meses" },
          {
            value: 4,
            text: "No, pero pienso intentarlo en los 30 próximos días"
          },
          {
            value: 5,
            text: "No, pero pienso intentarlo en los 6 próximos meses"
          },
          {
            value: 6,
            text: "No, y no pienso intentarlo en los 6 próximos meses"
          }
        ],
        optionsExerciseType: [
          {
            value: 1,
            text:
              "Sobrecarga: Entrenamiento con pesas, TRX, bandas elásticas o con el propio peso como sentadillas, flexiones de brazo, etc."
          },
          {
            value: 2,
            text:
              "Otra actividad: Trote, deporte, elíptica, bicicleta, zumba, etc."
          },
          { value: 3, text: "Sobrecarga y otras actividades" }
        ],
        optionsTimesWeek: [
          { value: 1, text: "1" },
          { value: 2, text: "2" },
          { value: 3, text: "3" },
          { value: 4, text: "4" },
          { value: 5, text: "5" },
          { value: 6, text: "6 o más" }
        ],
        optionsIntensity: [
          {
            value: 1,
            text:
              "Intensidad baja principalmente y algunos ejercicios con intensidad media"
          },
          {
            value: 2,
            text:
              "Intensidad media principalmente y algunos ejercicios con alte intensidad"
          },
          {
            value: 3,
            text: "Intensidad alta o muy alta en la mayoría de los ejercicios"
          }
        ],
        optionsPlace: [
          { value: 1, text: "Casa, con implementos" },
          { value: 2, text: "Casa, sin implementos" },
          {
            value: 3,
            text:
              "Gym de cadena o propio equipado con varias máquinas de ejercicios y cardiovasculares, set de mancuernas, pesos libres, etc."
          },
          { value: 4, text: "Gym edificio o casa poco equipado" }
        ],
        optionsTools: [
          { value: 1, text: "TRX" },
          { value: 2, text: "Bandas elásticas" },
          { value: 3, text: "Mancuernas" },
          { value: 4, text: "Fitball" },
          { value: 5, text: "Colchoneta" },
          { value: 6, text: "Elíptica" },
          { value: 7, text: "Bicicleta" },
          { value: 8, text: "Corredora" },
          { value: 9, text: "Máquina de ejercicios multifuncional" },
          { value: 11, text: "Barra" },
          { value: 12, text: "Matt de yoga" },
          { value: 13, text: "Polea" },
          { value: 14, text: "Disco" },
          { value: 15, text: "Banco" }
        ],
        optionsBuyTools: [
          { value: 1, text: "Sí" },
          { value: 2, text: "No" }
        ],
        optionsDays: [
          { value: 0, text: "lunes" },
          { value: 1, text: "martes" },
          { value: 2, text: "miércoles" },
          { value: 3, text: "jueves" },
          { value: 4, text: "viernes" },
          { value: 5, text: "sábado" },
          { value: 6, text: "domingo" }
        ],
        optionsTimePerDay: [
          { value: 1, text: "30 mins" },
          { value: 2, text: "45 mins" },
          { value: 3, text: "60 mins" },
          { value: 4, text: "90 mins" },
          { value: 5, text: "120 mins" }
        ]
      }
    };
  },
  validations: {
    formData: {
      observation: {
        maxLength: maxLength(2000)
      }
    }
  },
  methods: {
    loadData: function(data) {
      this.formData = data
    },
    validate: function() {
      this.$v.formData.$touch();
      var isValid = !this.$v.formData.$invalid
      this.$emit('on-validate', isValid)
      return isValid
    }
  }
};
</script>

<style>
.option-exercise-amount {
  display: inline-block;
  width: 50%;
  padding-bottom: 0.25rem;
  padding-top: 0.25rem;
  margin: 0;
}
</style>